import dayjs from 'dayjs'

const jstFromUtc = (input) => {
  const local = dayjs(input).toDate()
  const utc = new Date(local.getTime() + 9 * 3600000)
  return utc
}

export const formatDate = (date, format = 'YYYY/MM/DD') => {
  if (!date) {
    return ''
  }
  return dayjs(jstFromUtc(date)).format(format)
}
